module.exports = __webpack_public_path__ + "static/media/osroColor2.aff1bdfa.jpg";